"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transliterateMap = {
    // # Greek-Coptic
    //   ## Archaic letters
    Ͱ: "",
    ͱ: "",
    Ͳ: "",
    ͳ: "",
    //   ## Numeral signs
    ʹ: "",
    "\u0375": "",
    //   ## Archaic letters
    Ͷ: "",
    ͷ: "",
    //   ## Iota subscript
    ͺ: "",
    //   ## Lowercase of editorial symbols
    ͻ: "",
    ͼ: "",
    ͽ: "",
    //   ## Additional letter
    // Ϳ: "", // GREEK CAPITAL LETTER YOT (U+037F)
    // ##  Capitals
    Α: "a",
    Β: "b",
    Γ: "g",
    Δ: "d",
    Ε: "e",
    Ζ: "z",
    Η: "ē",
    Θ: "th",
    Ι: "i",
    Κ: "k",
    Λ: "l",
    Μ: "m",
    Ν: "n",
    Ξ: "x",
    Ο: "o",
    Π: "p",
    Ρ: "r",
    Σ: "s",
    Τ: "t",
    Υ: "y",
    Φ: "ph",
    Χ: "ch",
    Ψ: "ps",
    Ω: "ō",
    //   ## Lowercase
    α: "a",
    β: "b",
    γ: "g",
    δ: "d",
    ε: "e",
    ζ: "z",
    η: "ē",
    θ: "th",
    ι: "i",
    κ: "k",
    λ: "l",
    μ: "m",
    ν: "n",
    ξ: "x",
    ο: "o",
    π: "p",
    ρ: "r",
    ς: "s",
    σ: "s",
    τ: "t",
    υ: "y",
    φ: "ph",
    χ: "ch",
    ψ: "ps",
    ω: "ō",
    //  ## Variant letterforms
    Ϗ: "",
    ϐ: "",
    ϑ: "",
    ϒ: "",
    ϓ: "",
    ϔ: "",
    ϕ: "",
    ϖ: "",
    ϗ: "",
    //   ## Archaic letters
    Ϙ: "",
    ϙ: "",
    Ϛ: "",
    ϛ: "",
    Ϝ: "",
    ϝ: "",
    Ϟ: "",
    ϟ: "",
    Ϡ: "",
    ϡ: "",
    //   ## Coptic letters derived from Demotic
    Ϣ: "",
    ϣ: "",
    Ϥ: "",
    ϥ: "",
    Ϧ: "",
    ϧ: "",
    Ϩ: "",
    ϩ: "",
    Ϫ: "",
    ϫ: "",
    Ϭ: "",
    ϭ: "",
    Ϯ: "",
    ϯ: "",
    //   ## Variant letterforms
    ϰ: "",
    ϱ: "",
    ϲ: "",
    //   ## Additional letter
    ϳ: "",
    // ## Variant letterforms and symbols
    ϴ: "",
    ϵ: "",
    "\u03F6": "",
    // ## Additional archaic letters for Bactrian
    Ϸ: "",
    ϸ: "",
    // ## Variant letterform
    Ϲ: "",
    // ## Archaic letters
    Ϻ: "",
    ϻ: "",
    // ## Symbol
    ϼ: "",
    // ## Editorial symbols
    Ͻ: "",
    Ͼ: "",
    Ͽ: "",
    // Characters from NFKD normalization
    "\u00B7": "",
    "\u0300": "",
    "\u0301": "",
    "\u0304": "",
    "\u0306": "",
    "\u0313": "",
    //   "\u{0314}": "\u{0314}", // DASIA (i.e. rough breathing mark) > COMBINING REVERSED COMMA ABOVE
    "\u0342": "",
    "\u0345": "" // YPOGEGRAMMENI > COMBINING GREEK YPOGEGRAMMENI
};
